import { useQuery } from '@tanstack/react-query';
import { monitorAPI } from 'api/monitor';

export interface SystemDateTime {
    systemDate: string;
    systemTime: string;
    systemTimezone: string;
}

export const SYSTEM_DATE_TIME_QUERY_KEY = ['monitor', 'system-datetime'];

const STALE_TIME_MS = 30000;

export default function useSystemDateTime(refetchInterval?: number) {
    return useQuery<SystemDateTime>({
        queryKey: SYSTEM_DATE_TIME_QUERY_KEY,
        queryFn: async () => {
            const response = await monitorAPI.loadSystemDateTimeData();
            if (response.data.status !== 'OK') {
                throw new Error('system-datetime request failed');
            }
            return response.data.data as SystemDateTime;
        },
        staleTime: STALE_TIME_MS,
        refetchInterval,
    });
}
